/**凯图的接口 与pc前端公用
 * Created by lxl on 2019/5/14.
 *
 * POST参数
 connect:1,        传输类型：TCP=1，UDP=2
 hostIP:'127.0.0.1',    设备ip地址。127.0.0.1为本机地址，可写其他主机局域网地址
 hostPort:5000,        设备连接的端口，默认是5000，不需要修改
 feedback:0,        是否有状态反馈，无反馈=0，有反馈=10
 contextData:’ ca 20 fe c1 04 03 05 00 01’        控制指令

 调光灯：渐变值0-FF，值越小执行速度越快 ，值越大执行速度越慢。亮度值0-100
 */
import $$ from "jquery";
let _headers = {
    'Content-Type': 'application/x-www-form-urlencoded;;charset=utf-8', 'Access-Control-Allow-Origin': '*' // 配合 data中的表单提交
};
let kt_path = '/cgi-bin/post.cgi';// 客户个人的地址
let data = {
    connect: 1,
    hostPort: 5000,
    feedback: 10,
    hostIP: '',
    contextData: ''
};

const KtApi = {
        /*****************************************************以下是凯图设备接口 brightness均为十进制百分比亮度***************************************************/

        setCommand(domain, sucfn2, failFn2) {
            var Xarr = ['01', '02', '03', '04'];
            var Yarr = ['10', '64', '2', '50', '3', '64','00'];

            for (var a = 0; a< 14; a++)  {
                for (var i = 0; i < 4; i++)  {
                    let command = 'ca 20 fe ce 06 01 32 X Y 00 ac ac';
                    command = command.replace('X', Xarr[i]);
                    command = command.replace('Y', Yarr[a]);
                    console.log(command)
                    KtApi.ajax('测试',domain, command, function (data) {
                        sucfn2(data);
                    }, failFn2);

                }
            }
        },
        /************************开关模块*************************/
        /**
         * 开关模块
         开：\xca\x20\xfe\xce\x05\id\x18\channel\x01\xac\xac
         关：\xca\x20\xfe\xce\x05\id\x18\x01\channel\xac\xac
         取反：\xca\x20\xfe\xce\x05\id\x18\x01\channel\xac\xac
         * @param id
         * @param channel
         * @param brightness
         * @param sucfn2
         * @param failFn2
         */
        setSwitchOpen: function (id,domain, channel, sucfn2, failFn2) {
            let command = 'ca 20 fe ce 05 x 18 v 01 ac ac';
            let params = {
                id: id,
                channel: channel
            };
            command = this.assembleCommand(command, params);
            this.ajax('开光模块设置：开通道' + channel,domain, command, sucfn2, failFn2)
            {
            }
        },
        setSwitchOff: function (id, channel, sucfn2, failFn2) {
            let command = 'ca 20 fe ce 05 x 18 v 00 ac ac';
            let params = {
                id: id,
                channel: channel
            };
            command = this.assembleCommand(command, params);
            this.ajax('开光模块设置：开通道' + channel,domain, command, sucfn2, failFn2)
            {
            }
        },
        /**
         * 端口状态查询: \xCA\x20\xFE\xCE\x05\x01\x20\x01\x01\xAC\xAC
         说明：01代表模块ID。
         4路-反馈格式：（04长度，后面是4路的端口状态  00表示 端口关，01表示 端口开）
         CA B0 01 04 01 01 01 01 AC
         8路-反馈格式：（08长度，后面是8路的端口状态）
         CA B0 01 08 01 01 01 01 00 00 00 00 AC
         * @param id
         * @param sucfn2
         * @param failFn2
         */
        getSwitchStatus: function (id,domain, sucfn2, failFn2) {
            let command = 'ca 20 fe ce 05 x 20 01 01 ac ac';
            let params = {
                id: id
            };
            var result;
            command = this.assembleCommand(command, params);
            this.ajax('开光模块状态查询',domain, command, function (data) {
                var item, i;
                // 8路开关
                if (data.channelNum == 8) {
                    for (i = 8; i < 12; i++) {
                        item = {
                            port: i - 3,
                            status: parseInt(data.dataArr[i - 4]) == 1,
                        };
                        brigthness.push(item)
                    }
                    // 4路开关
                } else if (data.channelNum == 4) {
                    for (i = 5; i < 9; i++) {
                        item = {
                            port: i,
                            status: parseInt(data.dataArr[i - 2]) == 1,
                        };
                    }
                }
                result.id = id;
                result.factoryType = 4;
                result.desc = '开关模块状态查询'
                sucfn2(result);
            }, failFn2)
            {
            }
        },
        /*********************************************开关模块结束****************************************************/

    /*********************************************灯光模块****************************************************/

    /**
     *
     * 调光端口状态查询: \xCA\x20\xFE\xCE\x05\x01\x21\x01\x01\xAC\xAC
     反馈格式： CA B0 02 02 01 01 AC
     反馈解析： 02：是反馈数据长度；
     01：2个反馈状态，00表示端口关，01表示端口开；
     */
    getLightStatus(id,domain,succfn2, failFn2){
        let command = 'ca 20 fe ce 05 x 21 01 01 ac ac';
        let params = {
            id: id
        };
        var  status=[];
        command = this.assembleCommand(command, params);
        this.ajax('灯光模块状态查询',domain, command, function (data) {
            var item, i;
            var result={}
            // 8路开关
            if (data.channelNum == 8) {
                for (i = 8; i < 12; i++) {
                    item = {
                        port: i - 3,
                        qStatus: parseInt(data.dataArr[i - 4]) == 1,
                        lightStatus: parseInt(data.dataArr[i]) == 1
                    };
                    status.push(item)
                }
                // 4路
            } else if (data.channelNum == 4) {
                for (i = 4; i < 8; i++) {
                    item = {
                        port: i - 3,
                        qStatus: true,
                        lightStatus: parseInt(data.dataArr[i]) == 1
                    };
                    status.push(item)
                }
            }else if (data.channelNum == 2) {
                for (i = 4; i < 6; i++) {
                    item = {
                        port: i - 3,
                        qStatus: true,
                        lightStatus: parseInt(data.dataArr[i]) == 1
                    };
                    status.push(item)
                }
            }
            result.status=status;
            result.id = id;
            result.factoryType = 4;
            result.desc = '灯光模块状态查询'
            succfn2(result);
        }, failFn2)
        {
        }
    },
        /**所有的灯光类型都经这里调光
         *  ca 20 fe ce 06 id 32 port brightness gradual ac ac  渐变固定为0
         *
         0-10调光，用的5-8端口，1-4是强电开光（）
         0%亮度：\xca\x20\xfe\xce\x06\x01\x32\x05\x00\x00\xac\xac
         10%亮度：\xca\x20\xfe\xce\x06\x01\x32\x05\x0a\x00\xac\xac
         20%亮度：\xca\x20\xfe\xce\x06\x01\x32\x05\x14\x00\xac\xac
         30%亮度：\xca\x20\xfe\xce\x06\x01\x32\x05\x1e\x00\xac\xac
         40%亮度：\xca\x20\xfe\xce\x06\x01\x32\x05\x28\x00\xac\xac
         50%亮度：\xca\x20\xfe\xce\x06\x01\x32\x05\x32\x00\xac\xac
         60%亮度：\xca\x20\xfe\xce\x06\x01\x32\x05\x3c\x00\xac\xac

         调色：用的 1 开始的端口 port（1-4）
         0%亮度：\xca\x20\xfe\xce\x06\id\x32\port\x00\x00\xac\xac
         10%亮度：\xca\x20\xfe\xce\x06\id\x32\port\x0a\x00\xac\xac
         20%亮度：\xca\x20\xfe\xce\x06\id\x32\port\x14\x00\xac\xac
         30%亮度：\xca\x20\xfe\xce\x06\id\x32\port\x1e\x00\xac\xac
         40%亮度：\xca\x20\xfe\xce\x06\id\x32\port\x28\x00\xac\xac
         50%亮度：\xca\x20\xfe\xce\x06\id\x32\port\x32\x00\xac\xac

         * @param id
         * @param port
         * @param brightness  注意这个是16进制,灯光百分比
         * @param sucfn2
         * @param failFn2
         */
        setBrightness: function (id,domain, port, brightness, sucfn2, failFn2) {
            console.log(brightness);
            let command = 'ca 20 fe ce 06 x 32 # y 03 ac ac';
            let params = {
                id: id,
                port: port,
                brightness: brightness
            };
            command = this.assembleCommand(command, params);
            this.ajax('调光绝对亮度值指令:' + '设备Id:' + id + '端口：' + port + '亮度：' + brightness,domain, command, sucfn2, failFn2)
            {
            }
        },

        /**
         * 设置颜色 port 1-4
         * @param id
         * @param color
         * @param w
         * @param sucfn2
         * @param failFn2
         */
        setColor: function (id,domain, color, w, sucfn2, failFn2) {
            if (color && color != '') {
                var percentArr = this.toColorPercentArr(color);
                // console.log(percentArr);
                this.setBrightness(id, domain, 1, percentArr[0], sucfn2, failFn2);
                this.setBrightness(id, domain, 2, percentArr[1], sucfn2, failFn2);
                this.setBrightness(id, domain, 3, percentArr[2], sucfn2, failFn2);
            }

            this.setBrightness(id,domain, 4, w, sucfn2, failFn2);
        },
        turnOnByPort(id,domain,port,sucfn2, failFn2) {
            if(port>4){
                this.setStatus(id,domain, port-4, '01',sucfn2, failFn2,'开启调光强电开关：'+port)
            }
            this.setStatus(id,domain, port, '01',sucfn2, failFn2,'开启调光通道开关：'+port)
        },

        turnOffByPort(id,domain,port,sucfn2, failFn2) {
            if(port>4){
                this.setStatus(id,domain, port-4, '00',sucfn2, failFn2,'关闭调光强电开关：'+port)
            }
            this.setStatus(id,domain, port, '00',sucfn2, failFn2,'关闭调光通道开关：'+port)
        },
     //一键开关 eid : kttg-4-01  zhilin: '01'/'00'
    turnOnOffAll(domain,eid,zhilin,sucfn2, failFn2) {
        var id=this.getIdByEid(eid)
        var port=this.getIdByPort(eid);
        var arr,arr2;
        if(eid.indexOf('kttg')!=-1){
            if(parseInt(port) == 2){
                arr = ['01', '02'];
                arr.map(function (item, index) {
                    KtApi.setStatus(id,domain, item, zhilin,sucfn2, failFn2,'关闭调光强电开关：'+index)
                })
            }else {
                arr = ['01', '02', '03', '04'];
                arr2 = ['05', '06', '07', '08'];
                arr.map(function (item, index) {
                    KtApi.setStatus(id,domain, item, zhilin,sucfn2, failFn2,'关闭调光强电开关：'+index)
                })
                arr2.map(function (item, index) {
                    KtApi.setStatus(id,domain, item, zhilin,sucfn2, failFn2,'关闭调光强电开关：'+index)
                })
            }

        }else{
            arr = ['01', '02', '03', '04'];
            arr.map(function (item, index) {
                KtApi.setStatus(id,domain, item, zhilin,sucfn2, failFn2,'关闭调光强电开关：'+index)
            })
        }
    },
        turnOffAll(id,domain,sucfn2, failFn2) {
            var arr = ['01', '02', '03', '04'];
            var arr2 = ['05', '06', '07', '08'];
            arr.map(function (item, index) {
                KtApi.setStatus(id,domain, item, '00',sucfn2, failFn2,'关闭调光强电开关：'+index)
            })

            arr2.map(function (item, index) {
                KtApi.setStatus(id,domain, item, '00',sucfn2, failFn2,'关闭调光通道开关：'+index)
            })
        },
        turnOnAll(id,domain,sucfn2, failFn2) {
            var arr = ['01', '02', '03', '04'];
            var arr2 = ['05', '06', '07', '08'];
            arr.map(function (item, index) {
                KtApi.setStatus(id,domain, item, '01',sucfn2, failFn2,'开启调光强电开关：'+index)
            })

            arr2.map(function (item, index) {
                KtApi.setStatus(id,domain, item, '01',sucfn2, failFn2,'开启调光通道开关：'+index)
            })
        },
        /**
         * 开启调色所有通道
         * @param id
         * @param sucfn2
         * @param failFn2
         */
        openColorAll(id,domain,sucfn2, failFn2) {
            var arr = ['01', '02', '03', '04'];
            arr.map(function (item, index) {
                KtApi.setStatus(id,domain, item, '01',sucfn2, failFn2,'开启调色所有通道：'+index)
            })
        },

        /**
         * 关闭调色所有通道
         * @param id
         * @param sucfn2
         * @param failFn2
         */
        closeColorAll(id,domain,sucfn2, failFn2) {
            var arr = ['01', '02', '03', '04'];
            arr.map(function (item, index) {
                KtApi.setStatus(id,domain, item, '00',sucfn2, failFn2,'关闭调色所有通道'+index)
            })
        },
        /**0-10V调光
         * 强电开：\xca\x20\xfe\xce\x05\id\x18\channel（1-4）\status\xac\xac
         强电关：\xca\x20\xfe\xce\x05\id\x18\channel（1-4）\status\xac\xac
         调光开：\xca\x20\xfe\xce\x05\id\x18\channel（5-8）\status\xac\xac
         调光关：\xca\x20\xfe\xce\x05\id\x18\channel（5-8）\status\xac\xac

         当关闭的时候（强电、调光都0），通过亮度查询返回的值为0或80（转换后也为0），但 再开启的时候，亮度恢复（有亮度记忆）

         颜色调光：
         调光开：\xca\x20\xfe\xce\x05\id\x18\x01\x01\xac\xac
         调光关：\xca\x20\xfe\xce\x05\id\x18\x01\x00\xac\xac

         说明：id代表模块ID，channel 01 / 05分别代表对应的0-10v调光上的强制开关和调光通道，共四组，分别为01 / 05、02 / 06、03 / 07、04 / 08。
         备注：注意关闭通道灯时，要通过强切开关切断的方式进行关灯；同理，开灯之前，需打开对应通道的强切开关。
         @lxl  按此理解 简单地开关应该为两条指令 ，如需开启通道1，需要执行  \xca\x20\xfe\xce\x05\id\x18\01\01\xac\xac

         和 \xca\x20\xfe\xce\x05\id\x18\05\01\xac\xac 两条指令，关闭同理
         * ca b0 03 08 01 01 00 00 01 00 00 00 ac  强电1,2开启和通道5开启后的返回
         */
        setStatus: function (id,domain, channel, status, sucfn2, failFn2,desc) {
            if (isNaN(id)) {
                failFn2('id应该为数字');
                return;
            }
            let command = 'ca 20 fe ce 05 x 18 v u ac ac';
            let params = {
                id: id,
                channel: channel,
                status: status
            };
            command = this.assembleCommand(command, params);
            var result = {};
            let brigthness = [];
            var that = this;
            console.log(command)
            this.ajax(desc?desc:'强电开关和通道开关',domain, command, function (data) {
                sucfn2(data);
            }, failFn2);
            {
            }
        },


        /**
         *  CA 20 FE CE 05 03 20 01 01 AC AC
         * 端口状态查询:  CA 20 FE CE 05 id 20 01 01 AC AC
         说明：01代表模块ID。
         反馈格式： CA B0 01 08 01 01 01 01 E0 E1 E2 E3 AC  ----  这是4路  应该是 0-10V调光  用于DA0410AA 型号
         解析：1. 继电器1-4端口，01为端口开启；00为端口关闭；(这里就是对应强电开关)
         2. 调光5-8端口如下：
         E0 E1 E2 E3 （-80）表示4个端口亮度值60 61 62 63，计算方式如下：
         端口5反馈值为：（E0-80=60）16进制，数码管显示：96（60：16进制转换为10进制）；
         端口6反馈值为：（E1-80=61）16进制，数码管显示：97（61：16进制转换为10进制）；
         端口7反馈值为：（E2-80=62）16进制，数码管显示：98（62：16进制转换为10进制）；
         端口8反馈值为：（E3-80=63）16进制，数码管显示：99（63：16进制转换为10进制）；


         查询颜色返回：ca b0 01 04 e3 80 80 80 ac  表示绿色 通道  g b a
         * @param id
         * @param type  路数
         * @param sucfn2
         * @param failFn2
         * @returns {*}
         */
        getBrightness: function (id,domain, sucfn2, failFn2) {
            console.log(id)
            if (isNaN(id)) {
                failFn2('id应该为数字');
                return;
            }
            let command = 'CA 20 FE CE 05 x 20 01 01 AC AC';
            let params = {
                id: id,
            };
            command = this.assembleCommand(command, params);
            var result = {};
            let brigthness = [];
            var that = this;
            that.ajax('亮度查询',domain, command, function (data) {
                var item, i;
                // console.log(data.dataArr);
                // 四路灯 非调色
                if (data.channelNum == 8) {
                    for (i = 8; i < 12; i++) {
                        item = {
                            port: i - 3,
                            status: parseInt(data.dataArr[i - 4]) == 1,
                            brightness: that.to10Bright(data.dataArr[i])
                        };
                        brigthness.push(item)
                    }
                    // 调色灯，只有四路通道
                } else if (data.channelNum == 4) {
                    for (i = 4; i < 8; i++) {
                        item = {
                            port: i - 3,
                            status: that.to10Bright(data.dataArr[i]) > 0,
                            brightness: that.to10Bright(data.dataArr[i])
                        };
                        brigthness.push(item)
                    }
                    result.color = KtApi.toColorHexByPct(brigthness[0].brightness, brigthness[1].brightness, brigthness[2].brightness);
                } else if (data.channelNum == 2) {
                    for (i = 4; i < 6; i++) {
                        item = {
                            port: i - 3,
                            status: that.to10Bright(data.dataArr[i]) > 0,
                            brightness: that.to10Bright(data.dataArr[i])
                        };
                        brigthness.push(item)
                    }
                }

                result.bright = brigthness;
                result.id = id;
                result.factoryType = 4;
                result.desc = '亮度查询'
                sucfn2(result);
            }, function (msg) {
                failFn2(msg)
            });
        },
        /********************************************************提交封装和其他函数******************************************************************/

        /**
         * ajax提交封装
         * @param description ：功能描述，便于提示信息容易理解，如：首页公告获取、商品信息获取等等
         * @param command ：具体指令
         * @param fn ：回调函数，返回JSON对象或者异常信息，接口请求异常时返回null，接口请求不通时返回error，外部调用需判断是否为null或者error
         * @param fn2 ：异步请求方法类型 默认post
         *
         *
         * 2019-05-13 增加 header
         */
        ajax: function (description,domain, command, fn, fn2) {
            // console.log('进入ajax');
            // console.log(domain);
            // console.log(command);
            // 去掉所有空格
            if (command.indexOf('#') != -1) {

                return fn2("参数非法，模块id不能为空");
            }
            if (command.indexOf('x') != -1) {
                return fn2("参数非法，端口不能为空");
            }
            if (command.indexOf('y') != -1) {
                return fn2("参数非法，亮度值不能为空");
            }
            if (command.indexOf('z') != -1) {
                return fn2("参数非法,渐变值不能为空");
            }
            let url;//
            //定义默认值
            let loads = true,   //默认true
                loading = true;  //默认false
            //vue 项目
            url = domain.domainName + kt_path;
            data.hostIP = domain.hostIp;//  注意大小写

            data.contextData = command;
            //ajax参数
            let ajaxData = {
                url: url,
                method: 'POST',
                dataType: 'TEXT',
                timeout: 10,
                header: _headers,
                data: {values: data},//以表单方式提交参数（JSON对象）, 如 {"field1": "value1", "field1": "value2"} (直接传JSON对像.) 凯图必须要这个
            };
            //发起ajax

            if (typeof(api) != "undefined") {
                api.ajax(ajaxData, function (ret, err) {//  如果是以 text  方式 返回才有值
                    if (loads == true) {
                        console.log('************************ 凯图 请求开始 start ************************');
                        console.log('接口描述：' + description);
                        console.log('请求URL：' + url);
                        console.log('你的参数：' + JSON.stringify(data));
                        if (ret) {
                            console.log('接口返回：' + JSON.stringify(ret));
                        } else {
                            console.log('接口返回：' + '没有返回结果');
                        }
                    }
                    // ret='CA 20 02 20 01 01 AC'
                    console.log(JSON.stringify(ret))
                    if (ret) { //请求服务器成功
                        //正常回调
                        this.succ(fn, fn2, ret, description);
                    } else { //请求服务器失败
                        this.err(fn, fn2, ret);
                        if (loads == true) console.log('错误信息：' + JSON.stringify(err));
                    }
                    if (loads == true) console.log('************************ 请求结束 end ************************');
                });
                // pc端
            } else {
                var result;
                $$.ajax({
                    type: "POST",    //请求类型
                    url: url,
                    // dataType: "json",//服务器返回的数据类型  未知类型
                    data: data,
                    success: function (data) {
                        // data='CA 20 02 20 01 01 AC'
                        //回调结果，如果成功
                        result = data;
                        KtApi.succ(fn, fn2, data, description);
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.log('失败');
                        KtApi.err(fn, fn2, errorThrown);
                    }, complete: function (XMLHttpRequest, textStatus) {
                        console.log('************************ 凯图 请求 start ************************');
                        console.log('接口描述：' + description);
                        console.log('请求URL：' + url);
                        console.log('请求headers：' + _headers);
                        console.log('你的参数：' + JSON.stringify(data));
                        if (result) {
                            console.log('接口返回：' + JSON.stringify(result));
                        } else {
                            console.log('接口返回：' + '没有返回结果');
                        }
                        console.log('************************ 请求结束 end ************************');
                    }
                });
            }


        },

        /**
         * 对结果进行数组化
         * @param fn
         * @param fn2
         * @param ret
         * @param desc 方法描述
         * Msg="Post successfully"
         * Feedback={'IP=192.168.1.100',Port=5000,Data='ca b0 03 08 01 00 00 00 e0 80 80 80 ac '}
         * 2019-05-17 记得要除掉带转义的
         */
        succ: function (fn, fn2, ret, desc) {
            if (ret.replace(/^\s+|\s+$/g, "") == 'Msg="Target no exist or can not be connected" Feedback=null') {
                fn2("主机不存在或离线！");
            } else if (ret.replace(/^\s+|\s+$/g, "") == 'Msg="Post successfully" Feedback=null') {
                fn2("设备不存在或离线！");
            } else if (ret.replace(/^\s+|\s+$/g, "") == 'Msg="Parameter  illegal" Feedback=null') {
                fn2("参数不正确！");
            } else if (ret.indexOf('ca' != -1)) {
                fn(this.formResult(ret.replace('Msg="Post successfully" Feedback=', ''), desc))
            } else {
                fn2("主机或设备异常");
            }
        },
        err: function (fn, fn2, ret) {
            fn2("网络错误或主机已离线" + ret);
        },

        /***************************************************普通工具**************************************************************/
        /**
         * 注意不能去掉空格
         * @param command
         * @param params id,port,brightness,gradual 分别是 模块id,端口，亮度和渐变值
         * @returns {*}
         *
         * x   模块id
         * #   port
         * u   状态（00 或 01）
         * v   channel  通道
         * w
         * y   亮度  1-100 16进制 百分比
         * z    渐变度  FF
         */
        assembleCommand: function (command, params) {
            if (params.id) {
                command = command.replace('x', this.toHex(params.id));
            }
            if (params.port) {
                command = command.replace('#', this.toHex(params.port));
            }
            if (params.brightness || params.brightness==0) {
                command = command.replace('y', this.toHex(params.brightness));
            }
            if (params.gradual) {
                command = command.replace('z', this.toHex(params.gradual));
            }
            if (params.status) {
                command = command.replace('u', this.toHex(params.status));
            }
            if (params.channel) {
                command = command.replace('v', this.toHex(params.channel));
            }
            return command;
        },

        /**
         * ktts-4-02
         * 类型 通道数 模块id
         */
        getIdByEid(eId){
            return eId.split('-')[2];//
        },
         getIdByPort(eId){
            return eId.split('-')[1];//
         },
        /**
         * 转为10机制的百分比灯光亮度,
         * 注意要减去 x80 十进制128
         */
        to10Bright(hex){
            if (!hex) {
                return '灯光亮度值不能为空'
            }
            return this.hex2Int(hex) - 128;//  128为x80 转换;//  128为x80 转换
        },
        /**
         * @param hex
         * @returns {hex|*}
         */
        hex2Int: function (hex) {
            return parseInt(hex, 16);
        },
        /**
         * 只有两位
         * @param dec
         * @returns {string|*}
         */
        toHex: function (dec) {
            var hex = (dec).toString(16);
            while (hex.length < 2) {
                hex = "0" + hex;
            }
            return hex;
        },

        /**转换成rgb字符串
         * 一共6位
         * @param dec
         * @returns {string|*}
         */
        toColorHex: function (r, g, b) {
            r = this.toHex(r);
            g = this.toHex(g);
            b = this.toHex(b);
            return '#' + r + g + b;
        },

        /**灯光亮度百分比转换成rgb字符串
         * 一共6位
         * @param dec
         * @returns {string|*}
         */
        toColorHexByPct: function (rpct, gpct, bpct) {
            var r = this.toHex(parseInt(rpct / 100 * 255));
            var g = this.toHex(parseInt(gpct / 100 * 255));
            var b = this.toHex(parseInt(bpct / 100 * 255));
            return '#' + r + g + b;
        },
        /**
         * rbg转为 int 数组, 这个实际是灯光百分比
         * @param dec
         * @returns {string|*}
         */
        toColorPercentArr: function (hex) {
            hex = hex.replace('#', "");
            var arr = [];
            for (let i = 0; i < hex.length; i += 2) {
                var int = parseInt(hex.slice(i, i + 2), 16)
                arr.push(parseInt(int / 255 * 100));
            }
            return arr;
        },
        /**
         * rbg转为 hex 数组
         * @param dec
         * @returns {string|*}
         */
        toColorHexArr: function (hex) {
            hex = hex.replace('#', "");
            var arr = [];
            for (let i = 0; i < hex.length; i += 2) {
                arr.push(hex.slice(i, i + 2));
            }
            console.log('转换后的颜色16' + JSON.stringify(arr))
            return arr;
        },
        /**
         * Feedback={'IP=192.168.1.100',Port=5000,Data='ca b0 03 08 01 00 00 00 e0 80 80 80 ac '}
         * @param feedback
         *
         * {ip: "192.168.1.100", port: "5000", data: "ca b0 03 08 01 00 00 00 e0 80 80 80 ac "}
         *
         * 返回：
         * {
     *   ip:'',  主机本地地址
     *   port:'', 端口
     *   rawData:'' 原始数据
     *   data:''   去掉空格后
     *   dataArr:''  data 两位切割后的数组
     *   channelNum:   通道数 第四组=[3]
     * }
         */
        formResult(feedback, desc){
            var arry = feedback.replace(/{/g, "").replace(/}/g, "").replace(/'/g, "").split(",");
            let result = {};
            arry.map(function (item, index) {
                var temp = item.split('=');
                result[temp[0].toLowerCase()] = temp[1]
                if (temp[0].toLowerCase() == 'data') {
                    var dataArr = [];
                    temp[1] = temp[1].replace(/\s+/g, "");// 去除所有空格
                    for (let i = 0; i < temp[1].length; i += 2) {
                        dataArr.push(temp[1].slice(i, i + 2));
                    }
                    result['dataArr'] = dataArr
                }
            });
            result['desc'] = desc;
            result['channelNum'] = parseInt(result.dataArr[3]);
            console.log('格式后返回：' + JSON.stringify(result));
            return result;
        },

        /**
         * 判断是否调光
         * @param eid
         * @returns {boolean}
         */
        isSetBright(eid){

            return eid.indexOf('kttg') != -1;
        },

        /**
         * 判断是否调色
         * @param eid
         * @returns {boolean}
         */
        isSetColor(eid){

            return eid.indexOf('ktts') != -1;
        },

    getKtSwitchNum(eid){

            return eid.split('-')[1];
    }


};
export default KtApi;